import React from 'react';
import { IconButton } from '@mui/material';
import Iconify from 'src/components/iconify';

const CustomEdge = ({ id, source, target, sourceX, sourceY, targetX, targetY, style, data }) => {
  const centerX = (sourceX + targetX) / 2;
  const centerY = (sourceY + targetY) / 2;  
  return (
    <>
      <path
        id={id}
        style={{
          ...style,
          strokeWidth: 4,
          stroke: 'black', 
          fill: 'transparent',
          markerEnd: 'url(#arrow)', 
        }}
        className="react-flow__edge-path"
        d={`M${sourceX},${sourceY} C${(sourceX + centerX) / 2},${sourceY} ${(targetX + centerX) / 2},${targetY} ${targetX},${targetY}`}
      />
      <foreignObject x={centerX - 10} y={centerY - 10} width={50} height={50}>
        <IconButton
          onClick={() => data?.onDelete(id, source, target)}
          style={{ backgroundColor: 'white', borderRadius: '50%' }}
          size="large"
        >
          <Iconify icon="material-symbols:close-rounded" />
        </IconButton>
      </foreignObject>
    </>
  );
};

export default CustomEdge;
